/*Generated from the `:::slide{key="ef566e42-d0e0-41e2-a870-0c86e8781907" slug="welcome"}` (simplified/001/001.mdx), `:::slide{key="ef0575bb-c3d9-4035-a294-4ac50c57105a" slug="intro"}` (simplified/001/001.mdx) directives, merged because they share one anchor. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, TextSizeSlider, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!TextSizeSlider) _missingMdxReference("TextSizeSlider", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.p) _missingMdxReference("html.p", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "6",
      children: _jsx(html.p, {
        children: "Welcome to Haniverse!",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "6",
      children: _jsx(html.p, {
        children: "Our goal is to help you master Mandarin, Hanzi, and everything Chinese!",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "6",
      children: _jsx(html.p, {
        children: "Before we start, drag the slider to choose a comfortable text size.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "0",
      kind: "TextSizeSlider",
      count: "6",
      children: _jsx(TextSizeSlider, {
        subtext: "You can always change it later from the menu button in the top-left corner.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "4",
      section: "1",
      kind: "p",
      count: "6",
      children: _jsx(html.p, {
        children: "You'll start by learning how to break down Chinese characters—they aren't just random lines!",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "5",
      section: "1",
      kind: "p",
      count: "6",
      children: _jsx(html.p, {
        children: "Once you spot the underlying patterns, thousands of characters will suddenly click.",
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
